import { UseCaseInteractor } from '../../../kernel/use-case'
import { UpdateUserPayload } from '../domain/user'
import { UserRepository } from '../domain/user.repository'

export const updateUserV3UseCase: UseCaseInteractor<
  [userRepository: UserRepository],
  [userId: string, payload: UpdateUserPayload],
  boolean
> =
  (userRepository: UserRepository) =>
  async (userId: string, payload: UpdateUserPayload): Promise<boolean> => {
    return userRepository.updateUserV3(userId, payload)
  }
